import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAutoLockContext } from '@pwc/auto-save-ui';
import userTokenService from 'common/services/security/userTokenService';

type Props = {
  contentThreadId: number | null;
};

type LockData = {
  id: string;
  user: string;
  userId: string;
};

type LockType = {
  data: {
    data: LockData[];
  };
  isLoading: boolean;
};

const useLock = ({ contentThreadId }: Props) => {
  const { acquireLockState } = useAutoLockContext() as {
    acquireLockState: LockType;
  };
  const [lockStatus, setLockStatus] = useState({
    name: '',
    isLocked: false,
    message: '',
  });

  const lockData = acquireLockState.data && acquireLockState.data.data;
  const isLockExist = lockData && lockData.length > 0;
  const isLockLoading = acquireLockState.isLoading;
  const { t } = useTranslation();

  useEffect(() => {
    if (isLockExist && contentThreadId !== null) {
      const result = lockData.find(
        (lock) =>
          lock.id === String(contentThreadId) &&
          String(lock.userId) !== userTokenService.getUserId()
      );
      if (result) {
        const { user } = result;
        setLockStatus({
          name: user,
          isLocked: true,
          message: t('unableToEditisCurrentlyEditing', { user }),
        });
      } else {
        setLockStatus({ name: '', isLocked: false, message: '' });
      }
    } else if (!isLockExist && !isLockLoading) {
      setLockStatus({ name: '', isLocked: false, message: '' });
    }
    // eslint-disable-next-line
  }, [lockData, isLockExist, isLockLoading, contentThreadId]);

  return lockStatus;
};

export default useLock;
